import axios from "axios";
import Config from "../../config/index";

import {
  CREATE_USERMACHINE_FAILURE,
  CREATE_USERMACHINE_REQUEST,
  CREATE_USERMACHINE_SUCCESS,
  DELETE_USERMACHINE_FAILURE,
  DELETE_USERMACHINE_REQUEST,
  DELETE_USERMACHINE_SUCCESS,
  GET_USERMACHINE_FAILURE,
  GET_USERMACHINE_REQUEST,
  GET_USERMACHINE_SUCCESS,
  UPDATE_USERMACHINE_FAILURE,
  UPDATE_USERMACHINE_REQUEST,
  UPDATE_USERMACHINE_SUCCESS,
  GET_USERS_FOR_PO_REQUEST,
  GET_USERS_FOR_PO_SUCCESS,
  GET_USERS_FOR_PO_FAILURE,
} from "./userMachineTypes";

let baseUrl = Config.baseUrl;

const getUserMachineMappingRequest = () => {
  return {
    type: GET_USERMACHINE_REQUEST,
  };
};

const getUserMachineMappingSuccess = (payload) => {
  return {
    type: GET_USERMACHINE_SUCCESS,
    payload: payload,
  };
};

const getUserMachineMappingFailure = (error) => {
  return {
    type: GET_USERMACHINE_FAILURE,
    payload: error,
  };
};

const getUserMachineMapping = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getUserMachineMappingRequest());

    let url = `${baseUrl}/usermachinemap?&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUserMachineMappingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getUserMachineMappingFailure(err.response));
      });
  };
};

// const getLabelsWithPaginationRequest = () => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_REQUEST,
//   };
// };

// const getLabelsWithPaginationSuccess = (payload) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_SUCCESS,
//     payload: payload,
//   };
// };

// const getLabelsWithPaginationFailure = (error) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_FAILURE,
//     payload: error,
//   };
// };

// const getLabelsWithPagination = (pageNo, rowsPerPage, search, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getLabelsWithPaginationRequest());

//     let url = `${baseUrl}/label_size?page_number=${
//       pageNo + 1
//     }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getLabelsWithPaginationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getLabelsWithPaginationFailure(err.response));
//       });
//   };
// };

const createUserMachineRequest = () => {
  return {
    type: CREATE_USERMACHINE_REQUEST,
  };
};

const createUserMachineSuccess = (payload) => {
  return {
    type: CREATE_USERMACHINE_SUCCESS,
    payload: payload,
  };
};

const createUserMachineFaliure = (error) => {
  return {
    type: CREATE_USERMACHINE_FAILURE,
    payload: error,
  };
};

const createUserMachine = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createUserMachineRequest());
    let url = `${baseUrl}/usermachinemap`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createUserMachineSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createUserMachineFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateUserMachineCenterRequest = () => {
  return {
    type: UPDATE_USERMACHINE_REQUEST,
  };
};

const updateUserMachineCenterSuccess = (payload) => {
  return {
    type: UPDATE_USERMACHINE_SUCCESS,
    payload: payload,
  };
};

const updateUserMachineCenterFaliure = (error) => {
  return {
    type: UPDATE_USERMACHINE_FAILURE,
    payload: error,
  };
};

const updateUserMachineCenter = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(updateUserMachineCenterRequest());
    let url = `${baseUrl}/usermachinemap`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateUserMachineCenterSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateUserMachineCenterFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteUserMachineRequest = () => {
  return {
    type: DELETE_USERMACHINE_REQUEST,
  };
};

const deleteUserMachineSuccess = (payload) => {
  return {
    type: DELETE_USERMACHINE_SUCCESS,
    payload: payload,
  };
};

const deleteUserMachineFaliure = (error) => {
  return {
    type: DELETE_USERMACHINE_FAILURE,
    payload: error,
  };
};

const deleteUserMachine = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteUserMachineRequest());
    let url = `${baseUrl}/usermachinemap?userMachineMapId=${id}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteUserMachineSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteUserMachineFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// const getPrintersForLabelCreationRequest = () => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_REQUEST,
//   };
// };

// const getPrintersForLabelCreationSuccess = (payload) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_SUCCESS,
//     payload: payload,
//   };
// };

// const getPrintersForLabelCreationFailure = (error) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_FAILURE,
//     payload: error,
//   };
// };

// const getPrintersForLabelCreation = (jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getPrintersForLabelCreationRequest());

//     let url = `${baseUrl}/asset/get_printer`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getPrintersForLabelCreationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getPrintersForLabelCreationFailure(err.response));
//       });
//   };
// };

const getUsersForPoRequest = () => {
  return {
    type: GET_USERS_FOR_PO_REQUEST,
  };
};

const getUsersForPoSuccess = (payload) => {
  return {
    type: GET_USERS_FOR_PO_SUCCESS,
    payload: payload,
  };
};

const getUsersForPoFailure = (error) => {
  return {
    type: GET_USERS_FOR_PO_FAILURE,
    payload: error,
  };
};

const getUsersForPo = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getUsersForPoRequest());

    let url = `${baseUrl}/usermachinemap/get_user`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUsersForPoSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getUsersForPoFailure(err.response));
      });
  };
};

export {
  getUserMachineMapping,
  createUserMachine,
  updateUserMachineCenter,
  deleteUserMachine,
  getUsersForPo,
};
